import { gql } from "@apollo/client";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import apollo, { API_CMS_PROVIDER } from "@/helpers/apollo";
import { CITY_FIELDS, cities2regions } from "@/helpers/cities";
import Cities from "@/pages/cities";

const fetchCities = createServerFn({ method: "GET" }).handler(async () => {
  const client = apollo();
  const query = gql`
    ${CITY_FIELDS}

    {
      cities(
        filters: { parentCity: { id: null } }
        sort: "nameShort:asc"
        pagination: { page: 1, pageSize: 1000 }
      ) {
        ...CityFields
      }
    }
  `;

  const response = await client.query({
    context: { clientName: API_CMS_PROVIDER },
    query,
  });

  return { regions: cities2regions(response.data.cities.data) };
});

export const Route = createFileRoute("/cities")({
  component: CitiesPage,
  head: () => ({
    links: [{ href: `${process.env.APP_URL}/cities`, rel: "canonical" }],
    meta: [
      { title: "All cities - Morty: Every. Escape room. Ever." },
      {
        content:
          "Explore a world of adventure with Morty: Discover escape rooms and haunted attractions in cities globally, and find your next thrilling experience.",
        name: "description",
      },
    ],
  }),
  headers: () => ({
    "Cache-Control": "s-maxage=3600, stale-while-revalidate=86400",
  }),
  loader: () => fetchCities(),
});

function CitiesPage() {
  const data = Route.useLoaderData();
  return <Cities {...data} />;
}
